import React, { Component } from 'react';
import { Form} from 'react-bootstrap';
import DropdownMapel from '../masterDropDown/DropdownMapel';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import {Switch} from '@material-ui/core';

class MapelForm extends Component {
    constructor(props) {
        super(props);
        this.initialState = {
            idProfilCbt: '',
            idSubProfilCbt: '',
            idMapel: '',
            idTematik: '',
            kkm:'',
            durasi: '',
            random: '',
            prosentaseEssay: '',
            pointBenar: '',
            pointSalah: '',
            pointTakTerjawab: ''      
        }  
          
        if(props.subProfil){
           this.state = props.subProfil
        } else {
           this.state = this.initialState;
        }
        this.handleChangeMapel = this.handleChangeMapel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);         
    }

    handleChange(event) {

    } 

    handleChangeMapel(event) {
        const value = event.target.value;
        this.setState({
            idMapel: value,
            idTematik: ''
        })
    } 
    
    handleChangeTema = (event) => {
        const value = event.target.value;

        this.setState({ 
            idTematik: value,
            idMapel: ''
        })
    }
    
    onChangeKp(e) {
        let isChecked = e.target.checked;
        let value = e.target.value;     
        if(isChecked) {                        
            this.setState(prevState => ({
                ...prevState, random: '1'
            }));
                           
        } else {
            this.setState(prevState => ({
                ...prevState, random:  '0'
            }));
        } 
    }

    handleSubmit(event) {
        event.preventDefault();
        // extract form data
        const formdata = new FormData(event.target)
        
        // convert FormData to json object
        // SOURCE: https://stackoverflow.com/a/46774073
        let json = {}
        formdata.forEach(function(value, prop){
            json[prop] = value
        }) 

        let random = this.state.random;
        if(random === undefined || random === '') random = '0';
        json = {...json, ['random']: random}
        
        this.props.onSubmitSubProfil(json);
        this.setState(this.initialState);
    }

    dropMapel(){
        return(
            <DropdownMapel mapel={this.props.mapel} />
        )
    }
    
    handleBack() {
        this.props.handleBack();
    }

    render() {
        const subProfil = this.state;      
        let pageTitle;
        if(subProfil.idSubProfilCbt) {
            pageTitle = <h2>Edit Mapel</h2>
        } else {
            pageTitle = <h2>Add Mapel</h2>
        }
        return (
           <div>
               <h4>{pageTitle}</h4>  
               <Form onSubmit={this.handleSubmit}>         
               <div className="row mb-3">                    
                    <div className="col-sm-6 col-xs-6">
                    <Form.Group controlId="idMapel">
                        <Form.Label>Mata Pelajaran :</Form.Label>
                        <select className="form-control"
                        name="idMataPelajaran"
                        value={this.state.idMapel} 
                        onChange={this.handleChangeMapel} >
                            <option value="">None...</option>
                            {this.dropMapel()}
                        </select>
                    </Form.Group>                        
                    </div>   

                    <div className="col-sm-6 col-xs-6">
                    <Form.Group controlId="tematik">
                        <Form.Label>Tematik :</Form.Label>
                        <select className="form-control"
                        name="idTematik"
                        value={this.state.idTematik} 
                        onChange={this.handleChangeTema} >
                            <option value="">None...</option>
                            {this.props.tematik.map((tema,i) =>
                                <option key={i} value={tema.idTematik}>{tema.namaTematik}</option>
                            )}
                        </select>
                    </Form.Group>                        
                    </div>                    
                </div>
                <div className="row mb-3">
                    <div className="col-sm-4 col-xs-4"> 
                        <Form.Group controlId="pointBenar">
                            <Form.Label>Point Benar :</Form.Label>
                            <Form.Control
                                type="number" maxLength={100}
                                name="pointBenar" 
                                defaultValue={subProfil.pointBenar === undefined  ? '1' : subProfil.pointBenar}
                                onChange={this.handleChange}                                   
                                placeholder="Point Benar..." required/>
                        </Form.Group>
                    </div>
                    <div className="col-sm-4 col-xs-4"> 
                        <Form.Group controlId="pointSalah">
                            <Form.Label>Point Salah :</Form.Label>
                            <Form.Control
                                type="number"
                                name="pointSalah" 
                                defaultValue={subProfil.pointSalah === undefined  ? '0' : subProfil.pointSalah}
                                onChange={this.handleChange}                                  
                                placeholder="Point Salah..." required/>
                        </Form.Group>
                    </div>
                    <div className="col-sm-4 col-xs-4"> 
                        <Form.Group controlId="pointTakTerJawab">
                            <Form.Label>Point Tidak Jawab :</Form.Label>
                            <Form.Control
                                type="number"
                                name="pointTakTerjawab" 
                                defaultValue={subProfil.pointTakTerjawab === undefined  ? '0' : subProfil.pointTakTerjawab}
                                onChange={this.handleChange}                                  
                                placeholder="Point Tidak Jawab..." required/>
                        </Form.Group>
                    </div>                  
                </div>
                <div className="row mb-3">
                    <div className="col-sm-4 col-xs-4"> 
                        <Form.Group controlId="durasi">
                            <Form.Label>Durasi :</Form.Label>
                            <Form.Control
                                type="number"
                                name="durasi" 
                                defaultValue={subProfil.durasi === undefined  ? '60' : subProfil.durasi}
                                onChange={this.handleChange}                                  
                                placeholder="Durasi..." required/>
                        </Form.Group>
                    </div>
                    <div className="col-sm-4 col-xs-4"> 
                        <Form.Group controlId="kkm">
                            <Form.Label>Ketuntasan Minimum :</Form.Label>
                            <Form.Control
                                type="number"
                                name="ketuntasanMinimum" 
                                defaultValue={subProfil.kkm === undefined  ? '65' : subProfil.kkm}
                                onChange={this.handleChange}                                  
                                placeholder="Ketuntasan Minimum..." required/>
                        </Form.Group>
                    </div>

                    <div className="col-sm-4 col-xs-4"> 
                        <Form.Group controlId="essay">
                            <Form.Label>Prosentase Essay :</Form.Label>
                            <Form.Control
                                type="number"
                                name="prosentaseEssay" 
                                defaultValue={subProfil.prosentaseEssay === undefined  ? '0' : subProfil.prosentaseEssay}
                                onChange={this.handleChange}                                  
                                placeholder="Ketuntasan Minimum..." required/>
                        </Form.Group>
                    </div>                    
                    <Form.Control type="hidden" name="idProfilCbt" value={this.props.idProfilCbt} /> 
                    <Form.Control type="hidden" name="idSubProfilCbt" value={subProfil.idSubProfilCbt} />  
                    <Form.Control type="hidden" name="random" value={subProfil.random == undefined ? 0 : subProfil.random} />                                       
                </div>
                    <Form.Group>
                        Random : <Switch color="primary" value={subProfil.random === undefined ? '0' : subProfil.random} onChange={e => this.onChangeKp(e)}
                            defaultChecked={ subProfil.random ? true : false }  />
                    </Form.Group>
                <div>
                    <button type="button" className="btn btn-danger" onClick={() => this.handleBack()}><ArrowBackIosIcon fontSize="small"/>Batal</button>
                
                    <button type="submit" className="btn btn-primary pull-right">Simpan</button>
                </div>
               </Form>
            </div>
        );
    }
}

export default MapelForm;